/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';

import { Grid,Card, CardContent  } from '@material-ui/core';
import { SeoComponent } from '../../components/Header/SeoComponent';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import LoginFormComponent from '../../components/Forms/LoginFormComponent';
import { useThemeData } from '../../context/ThemeDataContext'
import {useQuery} from "@apollo/client";
import {GET_PAGE} from "../../queries";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ReactHtmlParser from "react-html-parser";

function Login(props) {
    const { site_id, site_name } = useThemeData().themeData.site;
    const {font_family, primary_color_2, favicon } = useThemeData().themeData.site.theme;
    const { alert_popup } = useThemeData().modules;
    const [alertPopup, setAlertPopup] = useState('');

    useEffect(() => {
        if (alert_popup) {
            setAlertPopup(alert_popup);
        }
    }, [alert_popup]);

    const closeButtonStyle = {
        position: 'absolute',
        right: 8,
        top: 8,
        // Increase the touch area for the close button
        padding: '10px', // This increases the area around the icon making it easier to touch
    };


    const { loading: loadingPage, error: errorPage, data: dataPage } =
        useQuery(GET_PAGE, {
            variables: {
                site_id: site_id,
                url: '/'
            },
            fetchPolicy: 'cache-and-network'
        })

    if (loadingPage) return <p>{props.t('Loading...')}</p>
    if (errorPage) return <p>{props.t('Looks like we have a problem...')}</p>
    if (!dataPage) return null

    return (
        <Grid item lg={12} md={12} className="loginscreen" style={{
            fontFamily: `${font_family}`,
            color: `${primary_color_2}`
        }}>
            <SeoComponent site_name={site_name} favicon={favicon} title='Home' omschrijving={dataPage.page.omschrijving} />
            <div>
                <Modal
                    open={alertPopup !== ''}
                    onClose={() => setAlertPopup('')}
                    aria-labelledby="modal-title"
                    aria-describedby="modal-description"
                >
                    <Box className="login_popup">
                        <IconButton
                            aria-label="close"
                            onClick={() => setAlertPopup('')}
                            sx={closeButtonStyle}
                        >
                            <CloseIcon />
                        </IconButton>
                        {/*<h2 id="modal-title">Alert</h2>*/}
                        <p id="modal-description">{ReactHtmlParser(alertPopup)}</p>
                    </Box>
                </Modal>
            </div>
            <Card style={{
                fontFamily: `${font_family}`,
                color: `${primary_color_2}`
            }}>
                <CardContent className="contact-text">
                <LoginFormComponent {...props} dataPage={dataPage}/>

            </CardContent >
            </Card>
        </Grid >
    )

}


export default React.memo(withTranslation(['message', 'login', 'register'])(Login));
